module.exports = __webpack_public_path__ + "img/6678204.png";